import {useState} from 'react'
import {useIntl} from 'react-intl'
import {Table} from 'src/feature/bite/component/Table'
import {getDateAndTime} from 'src/feature/bite/helpers/date'
import {useStore} from 'src/feature/store/hook'
import FilterDrawerTrx from '../FilterDrawerTrx'

const StoreTransactions = ({loading, storeId}: {loading: boolean; storeId?: string}) => {
  const intl = useIntl()
  const {detail, detailSet, tabFilter, tabFilterSet} = useStore()
  const [open, setOpen] = useState(false)

  const data = detail?.Transaction?.dataList || []
  const paging = detail?.Transaction?.paging || {
    currentPageNumber: 1,
    totalPagesNumber: 0,
    pageSize: 1,
    totalCount: 0,
  }

  const Columns = [
    {
      key: 'OrderId',
      dataIndex: 'orderId',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.ORDER_ID'}),
    },
    {
      key: 'Date',
      dataIndex: 'date',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.DATE_TIME'}),
      render: (text: string) => <>{getDateAndTime(text)}</>,
    },
    {
      key: 'TerminalId',
      dataIndex: 'posNo',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.TERMINAL_ID'}),
      render: (text: string | null) => {
        return <>{!text ? '-' : text}</>
      },
    },
    {
      key: 'Type',
      dataIndex: 'type',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.TYPE'}),
      render: (text: string) => {
        let color = 'text-success'

        switch (text) {
          case 'Cancel':
            color = 'text-error'
            break
          case 'Refund':
            color = 'text-refund'
            break
          case 'Sale':
            color = 'text-success'
            break
          case 'SignUp':
            color = 'text-signup'
            break
          case 'Birthday':
            color = 'text-info'
            break
          default:
            color = 'text-success'
            break
        }

        return <span className={color}>{text}</span>
      },
    },
    {
      key: 'Amount',
      dataIndex: 'paidAmount',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.AMOUNT'}),
      /* render: (amount: any) => <div style={{textAlign: 'right'}}>{amount.toFixed(2)}</div>, */
      customMonetize: true,
    },
    {
      key: 'Channel',
      dataIndex: 'channel',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.CHANNEL'}),
    },
    {
      key: 'MemberName',
      dataIndex: 'memberName',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.MEMBER_NAME'}),
      render: (text: string) => (
        <>{text && text !== '' && text !== ' ' ? text : 'Fast Onboarded'}</>
      ),
    },
    /*  {
      key: 'StoreId',
      dataIndex: 'storeNo',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.STORE_ID'}),
    }, */
    {
      key: 'detailURL',
      dataIndex: 'transactionId',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.ACTION'}),
      render: (transactionId: string, detail: any) => (
        <a
          href={`/transaction/${transactionId}?stores=${detail?.storeNo || storeId}`}
          className='text-primary'
        >
          {intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.DETAIL'})}
        </a>
      ),
    },
  ]

  return (
    <>
      <FilterDrawerTrx setOpen={setOpen} open={open} />
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <div>
              <h3 className='fw-bold mb-2 mt-5'>
                {intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS'})}
              </h3>
              <p className=' fw-normal fs-6'>
                {intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS_TOOLTIP'})}
              </p>
            </div>
          </div>
          <div className='card-toolbar'>
            <div className='d-flex justify-content-end' data-kt-customer-table-toolbar='base'>
              <div className='d-flex align-items-center gap-2 gap-lg-3'>
                <button
                  className='btn btn-light'
                  onClick={() => setOpen(true)}
                  // id='kt_filter_membertrx_button'
                >
                  <i className='bi bi-sliders fs-4 me-4'></i>
                  {intl.formatMessage({id: 'GLOBAL.FILTER'})}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className='card-body pt-0'>
          <div className='table-responsive'>
            <Table
              loading={loading}
              dataSource={data}
              columns={Columns}
              pagination={{
                current: paging.currentPageNumber,
                pageSize: paging.pageSize,
                total: paging.totalCount,
                onChange: (page: any) => {
                  if (!detail || !detail.Transaction) return
                  const {pageSize, current} = page
                  const currentPage = pageSize !== detail.Transaction.paging.pageSize ? 1 : current

                  detailSet({
                    ...detail,
                    Transaction: {
                      ...detail.Transaction,
                      paging: {
                        ...paging,
                        currentPageNumber: currentPage,
                        pageSize: pageSize,
                      },
                    },
                  })

                  tabFilterSet({
                    ...tabFilter,
                    paging: {
                      currentPageNumber: currentPage,
                      pageSize: pageSize,
                    },
                  })
                },
              }}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default StoreTransactions
